import { createResource } from 'react-resource-router';

import { type UiPreferences } from '../../../common/types';
import { getUiPreferencesEndpoint } from '../endpoints';

export const uiPreferencesResource = createResource<UiPreferences>({
	type: 'uiPreferencesResource',
	getKey: () => 'uiPreferencesResource',
	getData: () => getUiPreferencesEndpoint(),
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
